module.exports = __webpack_public_path__ + "img/icon-ba.dd4f59c6.svg";